import React from 'react';

/**
 * FOS Watermark Component
 * Displays a subtle FOS logo watermark on portal pages
 */
const FOSWatermark = ({ opacity = 0.08, size = 'lg' }) => {
  const sizeClasses = {
    sm: 'w-16 sm:w-20',
    md: 'w-20 sm:w-24',
    lg: 'w-24 sm:w-32',
    xl: 'w-32 sm:w-40'
  };

  return (
    <div 
      className="fixed bottom-3 right-3 sm:bottom-4 sm:right-4 pointer-events-none z-10 select-none"
      style={{ opacity }}
      aria-hidden="true"
    >
      <div className={`${sizeClasses[size]} relative`}>
        <img 
          src="/fos-logo.png" 
          alt="" 
          className="w-full h-auto object-contain drop-shadow-sm"
          draggable="false"
        />
      </div>
    </div>
  );
};

export default FOSWatermark;
